package one.healthium.onboarding.ui.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.AppTheme

@Composable
fun EmojiBox(
    modifier: Modifier = Modifier,
    emojiHeight: Int?,
    emoji: String?,
) {
    if (emoji.isNullOrEmpty()) return

    Box(
        modifier = Modifier
            .size(emojiHeight?.dp ?: 40.dp)
            .then(modifier),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = emoji,
            style = AppTheme.textStyles.body1,
            fontWeight = FontWeight.Bold,
            textAlign = TextAlign.Center,
        )
    }
}